import Result from '../../shared/classes/Result'

export const promiseToResult = <T = any, U = any> (promise: Promise<T>): Promise<Result<T, U>> => {
  return promise
    .then((v: any) => {
      if (v.status !== 200) {
        throw Result.Error(v)
      }

      return Result.Done(v)
    }) as any
}
